import React from 'react';

/**
 * Converts newlines in text to JSX elements for proper rendering
 * @param text - The text containing newlines
 * @returns JSX elements with proper line breaks
 */
export const renderTextWithNewlines = (text: string): React.ReactNode => {
  if (!text) return null;
  
  return text.split('\n').map((line, index, array) => (
    <span key={index}>
      {line}
      {index < array.length - 1 && <br />}
    </span>
  ));
};

/**
 * Preserves newlines when sending text to backend
 * @param text - The text to process
 * @returns Text with preserved newlines
 */
export const preserveNewlines = (text: string): string => {
  if (!text) return '';
  return text.trim();
};

/**
 * Validates text input and handles newlines
 * @param text - The text to validate
 * @param maxLength - Maximum allowed length
 * @returns Validation result
 */
export const validateTextWithNewlines = (text: string, maxLength: number = 1000) => {
  if (!text || !text.trim()) {
    return { isValid: false, message: 'متن نمی‌تواند خالی باشد' };
  }
  
  if (text.length > maxLength) {
    return { isValid: false, message: `متن نمی‌تواند بیشتر از ${maxLength} کاراکتر باشد` };
  }
  
  return { isValid: true, message: '' };
};

/**
 * Counts actual characters including newlines for display
 * @param text - The text to count
 * @returns Character count
 */
export const getTextLength = (text: string): number => {
  return text ? text.length : 0;
};